import React from "react";
import { gaTrackCta } from "../../analytics/ga4";
import { MOBILE_PRIMARY_NAV } from "../../core/constants";
import { BOTTOM_NAV_HEIGHT_PX } from "../../core/breakpoints";
import { useI18n } from "../../features/i18n/LocaleProvider";
import NavItemButton from "./NavItemButton";

export default function BottomNav({ page, setPage, acc, analyticsScreen }) {
  const { t } = useI18n();
  const screen = analyticsScreen || page;

  const navigate = (id, labelKey) => {
    gaTrackCta({ cta_id: `nav_${id}`, cta_label: t(labelKey), destination: id, screen_class: screen });
    setPage(id);
  };

  return (
    <nav
      className="ecliptica-bottom-nav"
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 50,
        height: BOTTOM_NAV_HEIGHT_PX,
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
        display: "flex",
        alignItems: "stretch",
        background: "rgba(8,12,32,0.96)",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        backdropFilter: "blur(20px)",
      }}
    >
      {MOBILE_PRIMARY_NAV.map((item) => (
        <NavItemButton
          key={item.id}
          item={item}
          active={page === item.id}
          acc={acc}
          label={t(item.labelKey)}
          variant="bottom"
          onClick={() => navigate(item.id, item.labelKey)}
        />
      ))}
    </nav>
  );
}
